/* Canvas particle typography, adapted for the Funtek page's native HTML heading. */
(() => {
  const heading = document.querySelector('.csa-hero h1');
  if (!heading) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const text = document.createElement('span');
  text.className = 'particle-heading-text';
  text.textContent = heading.textContent;
  heading.replaceChildren(text);
  const canvas = document.createElement('canvas');
  canvas.className = 'particle-heading-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  heading.append(canvas);
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  let points = [], raf = 0, start = 0, previous = 0, visible = true, built = false, width = 0, height = 0;
  let timer, generation = 0;
  const pointer = { active: false, x: 0, y: 0 };
  const padding = 100;
  const stop = () => { cancelAnimationFrame(raf); raf = 0; previous = 0; };
  const run = () => { if (!raf && visible && !document.hidden && !reduce.matches && points.length) raf = requestAnimationFrame(draw); };
  function draw(now) {
    raf = 0;
    const dt = previous ? Math.min((now - previous) / 16.667, 2) : 1;
    previous = now;
    ctx.clearRect(0, 0, width, height);
    let moving = false;
    for (const p of points) {
      const t = Math.max(0, Math.min(1, (now - start - p.delay) / 1600));
      const ease = 1 - Math.pow(1 - t, 3);
      let x = p.sx + (p.tx - p.sx) * ease, y = p.sy + (p.ty - p.sy) * ease;
      if (pointer.active && fine.matches) {
        const dx = x - pointer.x, dy = y - pointer.y, dist = Math.hypot(dx, dy);
        if (dist < 95 && dist > 0) { const f = Math.pow(1 - dist / 95, 2) * 42; x += dx / dist * f; y += dy / dist * f; }
      }
      const follow = 1 - Math.pow(0.78, dt);
      p.x += (x - p.x) * follow; p.y += (y - p.y) * follow;
      if (t < 1 || Math.abs(x-p.x) + Math.abs(y-p.y) > 0.08) moving = true;
      ctx.globalAlpha = 0.35 + t * 0.65;
      ctx.fillStyle = p.color;
      ctx.fillRect(p.x, p.y, p.size, p.size);
    }
    ctx.globalAlpha = 1;
    heading.dataset.particleState = moving ? 'animating' : 'settled';
    if (moving) run();
  }
  async function build(replay = false) {
    const version = ++generation;
    stop();
    heading.classList.remove('particle-heading-ready');
    if (reduce.matches) { heading.dataset.particleState = 'reduced-motion'; return; }
    await document.fonts.ready;
    if (version !== generation || reduce.matches) return;
    const box = heading.getBoundingClientRect(), cs = getComputedStyle(text);
    if (!box.width || !box.height) return;
    width = Math.ceil(box.width + padding*2); height = Math.ceil(box.height + padding*2);
    const dpr = Math.min(devicePixelRatio || 1, 2);
    canvas.width = Math.round(width*dpr); canvas.height = Math.round(height*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
    const mask = document.createElement('canvas'); mask.width=width; mask.height=height;
    const mc=mask.getContext('2d',{willReadFrequently:true});
    mc.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    if ('letterSpacing' in mc) mc.letterSpacing=cs.letterSpacing;
    mc.fillStyle='#fff'; mc.textBaseline='alphabetic';
    const node=text.firstChild, lines=[];
    for(let i=0;i<node.length;i++) {
      const range=document.createRange();range.setStart(node,i);range.setEnd(node,i+1);
      const r=range.getBoundingClientRect();
      let line=lines.find(l=>Math.abs(l.top-r.top)<2);
      if(!line){line={top:r.top,left:r.left,height:r.height,text:''};lines.push(line);}
      line.text+=node.textContent[i];
    }
    for(const line of lines){
      const metrics=mc.measureText(line.text);
      const ascent=metrics.fontBoundingBoxAscent || parseFloat(cs.fontSize)*0.8;
      const descent=metrics.fontBoundingBoxDescent || parseFloat(cs.fontSize)*0.2;
      const baseline=line.top-box.top+padding+(line.height-ascent-descent)/2+ascent;
      mc.fillText(line.text.trimEnd(),line.left-box.left+padding,baseline);
    }
    const pixels=mc.getImageData(0,0,width,height).data;
    let step=innerWidth<600?4:3;
    const targets=[];
    for(let y=0;y<height;y+=step)for(let x=0;x<width;x+=step)if(pixels[(y*width+x)*4+3]>70)targets.push({x,y});
    const cap=innerWidth<600?1800:4800, stride=Math.max(1,Math.ceil(targets.length/cap));
    const enter=!built||replay;
    points=targets.filter((_,i)=>i%stride===0).map((v,i)=>{
      const seed=((i*9301+49297)%233280)/233280, angle=seed*Math.PI*2;
      const spread=enter?(innerWidth<600?52:90)*(0.4+seed):0;
      const sx=v.x+Math.cos(angle)*spread, sy=v.y+Math.sin(angle)*spread;
      return {tx:v.x,ty:v.y,sx,sy,x:sx,y:sy,delay:enter?seed*420:0,size:innerWidth<600?2.5:2.2,color:i%9===0?'#bad2dc':'#f7f0df'};
    });
    built=true;start=performance.now()-(enter?0:2200);
    heading.classList.add('particle-heading-ready');
    heading.dataset.particleCount=String(points.length);
    run();
  }
  heading.addEventListener('pointermove', e=>{
    if(!fine.matches || reduce.matches)return;
    const r=heading.getBoundingClientRect();pointer.active=true;pointer.x=e.clientX-r.left+padding;pointer.y=e.clientY-r.top+padding;run();
  },{passive:true});
  heading.addEventListener('pointerleave',()=>{pointer.active=false;run();});
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)run();else{pointer.active=false;stop();}}, {threshold:0}).observe(heading);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else run();});
  let oldSize='';
  new ResizeObserver(()=>{const size=`${heading.clientWidth}:${heading.clientHeight}`;if(size===oldSize)return;oldSize=size;clearTimeout(timer);timer=setTimeout(()=>build(),120);}).observe(heading);
  reduce.addEventListener('change',()=>build());
  fine.addEventListener('change',()=>{pointer.active=false;run();});
  document.querySelector('[data-replay-particles]')?.addEventListener('click',()=>build(true));
})();
